const SelectionTypes = {
  FROM: 'from',
  TO: 'to',
};

export {SelectionTypes};
